import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import { Tabs } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import TableContent from 'modules/timeoff/components/TimeoffSettings/TableContent'
import { buildTabs } from 'modules/timeoff/components/TimeoffSettings/tabs'
import { TabTypes } from 'modules/timeoff/lib/TimeoffSettings'

const LocationsContainer = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  // Determine which tab is active based on the pathname
  const getActiveTabId = (): string => {
    if (pathname.includes('/absence-types')) {
      return TabTypes.absenceTypes
    }
    if (pathname.includes('/approval-groups')) {
      return TabTypes.approvalGroups
    }
    if (pathname.includes('/blocked-periods')) {
      return TabTypes.blockedPeriods
    }
    // Default to policies
    return TabTypes.policies
  }

  const tabId = getActiveTabId()
  const tabs = buildTabs(navigation)
  const currentPathname = pathname

  return (
    <ResponsivePage.Body showHeader={false}>
      <Tabs
        currentId={currentPathname}
        onTabClicked={(tabHref) => {
          navigate(tabHref)
        }}
      >
        {tabs.map((tab) => (
          <Tabs.Tab key={tab.href} id={tab.href} label={tab.name} />
        ))}
      </Tabs>
      <TableContent tabId={tabId} />
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default LocationsContainer
